module.exports = __webpack_public_path__ + "static/media/career.7ae21dd4.svg";